import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {ExtraAction} from 'ducks/types';
import {fetchXeroAccounts} from 'ducks/tenancy';
import {MODALS} from 'ducks/oneOffChargeReasons';

import {EditOneOffChargeReasonForm} from './components';

import './styles.css';

const Buttons = ({triggerSubmit, submitting, onClose}) => (
  <div className="colab-row-space-between">
    <Button onClick={onClose} transparent white className="cancel">
      Cancel
    </Button>
    <Button
      onClick={triggerSubmit}
      className="submit"
      blue={!submitting}
      disabled={submitting}
      loading={submitting}>
      Save
    </Button>
  </div>
);

interface EditOneOffChargeReasonModalProps {
  closeModal: () => void;
  locationRef: string;
  storeDataExtraActions: (data) => ExtraAction[];
  data: any;
}

class EditOneOffChargeReasonModal extends React.Component<
  EditOneOffChargeReasonModalProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  componentDidMount() {
    const {locationRef} = this.props;

    this.props.fetchXeroAccounts(
      {location: locationRef},
      this.props.storeDataExtraActions(data => ({
        xeroAccounts: data
      }))
    );
  }

  triggerFormSubmit = () => {
    this.props.submit('editOneOffChargeReason');
  };

  render() {
    const {form: {submitting}, data: {xeroAccounts}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="EditOneOffChargeReasonModal"
        type={Modal.EXTRA_SMALL}>
        <Modal.Header heading="Edit charge reason " />
        <Modal.Body>
          <EditOneOffChargeReasonForm
            locationRef={this.props.locationRef}
            xeroAccounts={xeroAccounts || []}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('editOneOffChargeReason')(state)
    }
  };
};

const mapDispatchToProps = {
  submit,
  fetchXeroAccounts
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  MODALS.EDIT_ONE_OFF_CHARGE_REASON
)(EditOneOffChargeReasonModal) as React.ComponentType<any>);
